import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getProducts } from '../../redux/actions/productActions';
import { getCategories } from '../../redux/actions/categoryActions';
import StoreLayout from '../../components/layout/StoreLayout';
import ProductCard from '../../containers/products/ProductCard';
import ProductFiltersModal from '../../modals/ProductFilterModal';

// Pour le filtre de prix
import { Range } from 'react-range';
import { getPublications } from '../../redux/actions/publicationActions';
import PublicationsCarousel from '../../components/web/publications/PublicationsCarousel';
import { responsivePublication } from '../../config/dataApi';
import { useIsMobileOrTablet } from '../../actions/screens/useIsMobileOrTablet';
import { MdFilterList } from 'react-icons/md';

const STEP = 1;
const MIN_PRICE = 1;
const MAX_PRICE = 10000000;

const CategoryDetailPage = () => {
  const dispatch = useDispatch();
  const { categoryId } = useParams();

  const isMobileOrTablet = useIsMobileOrTablet();

  const { products, loading, error } = useSelector((state) => state.products);
  const { categories } = useSelector((state) => state.categories);

  const { publications } = useSelector((state) => state.publications);

  const [filters, setFilters] = useState({
    name: '',
    categoryId,
    minPrice: MIN_PRICE,
    maxPrice: MAX_PRICE,
  });

  const [priceRange, setPriceRange] = useState([MIN_PRICE, MAX_PRICE]);
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  // Récupérer la catégorie courante
  const currentCategory = categories.find(cat => cat._id === categoryId);

  // Charger les produits au montage
  useEffect(() => {
    if (categoryId) {
      dispatch(getPublications());
      dispatch(getProducts({ categoryId }));
    }
    dispatch(getPublications());
    dispatch(getCategories());
  }, [dispatch]);

  // Appliquer les filtres dynamiquement
  useEffect(() => {
    dispatch(getProducts(filters));
  }, [filters]);

  const handleSearchChange = (e) => {
    setFilters({ ...filters, name: e.target.value });
  };

  const handlePriceChange = (values) => {
    setPriceRange(values);
    setFilters({ ...filters, minPrice: values[0], maxPrice: values[1] });
  };

  const applyFilters = () => {
    dispatch(getProducts(filters));
    setShowMobileFilters(false);
  };

  const resetFilters = () => {
    setPriceRange([MIN_PRICE, MAX_PRICE]);
    setFilters({
      name: '',
      categoryId,
      minPrice: MIN_PRICE,
      maxPrice: MAX_PRICE
    });
    dispatch(getProducts({ categoryId }));
  };

  const totalPages = Math.ceil(products.length / itemsPerPage);
  const paginatedProducts = products.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <StoreLayout>
      <div className="container py-5">
        {/* En-tête de la catégorie */}
        <div className="mb-4 p-4 bg-white rounded shadow-sm border-start border-4 border-danger">
          <h1 className="text-3xl font-bold text-dark mb-2">
            {currentCategory?.name || "Catégorie inconnue"}
          </h1>
          <p className="text-muted">
            {currentCategory?.description || "Aucune description disponible."}
          </p>
        </div>

{
          isMobileOrTablet && (
            <div className="d-flex  align-items-center gap-3 mb-4 justify-content-between">
          <input
            type="text"
            placeholder="Rechercher un produit..."
            value={filters.name}
            onChange={handleSearchChange}
            className="form-control w-auto flex-grow-1 d-md-none ms-auto"
          />

          <button
            className="btn btn-outline-danger d-md-none ms-auto"
            onClick={() => setShowMobileFilters(true)}
          >
            <MdFilterList size={24} /> Filtres
          </button>
        </div>
          )
        }


        <div className="row g-4">
          {/* Sidebar Filtres (col-md-3) */}
          {
                      !isMobileOrTablet && (
                        
                      <div className="col-md-3">
                      <div className="card shadow-sm border-0 sticky-md-top" style={{ top: '80px' }}>
                        <div className="card-body">
                          <h5 className="card-title fw-bold mb-3">Recherche</h5>
          
                          <hr className="my-3" />
          
                          {/* Recherche */}
                          <div className="mb-3">
                            {/* <label className="form-label">Nom du produit</label> */}
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Rechercher..."
                              value={filters.name}
                              onChange={handleSearchChange}
                            />
                          </div>
          
                         
          
                          {/* Prix */}
                          <div className="mb-3">
                            <label className="form-label">Prix</label>
                            <Range
                              step={STEP}
                              min={MIN_PRICE}
                              max={MAX_PRICE}
                              values={priceRange}
                              onChange={(values) => handlePriceChange(values)}
                              renderTrack={({ props, children }) => (
                                <div {...props} className="range-track" style={{
                                  height: "6px",
                                  width: "100%",
                                  backgroundColor: "#ccc"
                                }}>
                                  {children}
                                </div>
                              )}
                              renderThumb={({ index, props }) => (
                                <div {...props} className="bg-danger" style={{
                                  height: "20px",
                                  width: "20px",
                                  borderRadius: "50%",
                                }} />
                              )}
                            />
                            <div className="mt-2 d-flex justify-content-between">
                              <span>{priceRange[0]} F</span>
                              <span>{priceRange[1]} F</span>
                            </div>
                          </div>
          
                          {/* Boutons */}
                          <div className="d-grid gap-2 mt-3">
                            <button className="btn btn-danger" onClick={applyFilters}>
                              Appliquer les filtres
                            </button>
                            <button className="btn btn-outline-secondary" onClick={resetFilters}>
                              Réinitialiser
                            </button>
                          </div>
                          <div>
                            <PublicationsCarousel publications={publications} responsive={responsivePublication} />
                          </div>
                        </div>
                      </div>
                    </div>
                    
                      )
                    }

          {/* Colonne principale (col-md-9) */}
          <div className="col-md-9">
            {loading ? (
              <div className="row my-4">
                {[...Array(6)].map((_, index) => (
                  <div className="col-md-4 mb-4" key={index}>
                    <div
                      className="card border-0 shadow-sm"
                      style={{
                        backgroundColor: "#f0f0f0",
                        height: "300px",
                        borderRadius: "10px",
                        animation: "pulse 1.5s infinite",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#e0e0e0",
                          height: "180px",
                          borderTopLeftRadius: "10px",
                          borderTopRightRadius: "10px",
                        }}
                      ></div>
                      <div className="p-3">
                        <div
                          style={{
                            height: "15px",
                            width: "70%",
                            backgroundColor: "#e0e0e0",
                            borderRadius: "5px",
                            marginBottom: "10px",
                          }}
                        ></div>
                        <div
                          style={{
                            height: "12px",
                            width: "50%",
                            backgroundColor: "#e0e0e0",
                            borderRadius: "5px",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                ))}
                <style>
                  {`
        @keyframes pulse {
          0% { background-color: #f0f0f0; }
          50% { background-color: #e0e0e0; }
          100% { background-color: #f0f0f0; }
        }
      `}
                </style>
              </div>
            ) : paginatedProducts.length === 0 ? (
              <div className="alert alert-secondary text-center">
                Aucun produit trouvé dans cette catégorie.
              </div>
            ) : (
              <>
                <div className="row g-4">
                  {paginatedProducts.map((product) => (
                    <div key={product._id} className="col-md-4">
                      <ProductCard product={product} />
                    </div>
                  ))}
                </div>

                {/* Pagination */}
                {!loading && products.length > itemsPerPage && (
                  <nav className="mt-5">
                    <ul className="pagination justify-content-center">
                      {Array.from({ length: totalPages }).map((_, i) => (
                        <li
                          key={i + 1}
                          className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}
                        >
                          <button
                            className="page-link"
                            onClick={() => setCurrentPage(i + 1)}
                          >
                            {i + 1}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </nav>
                )}
              </>
            )}
          </div>
        </div>

        {/* Modale mobile */}
        <ProductFiltersModal
          show={showMobileFilters}
          onHide={() => setShowMobileFilters(false)}
          filters={filters}
          onApply={applyFilters}
          onReset={resetFilters}
          onPriceChange={setPriceRange}
          onCategoryChange={() => { }}
          categories={categories}
        />
      </div>
    </StoreLayout>
  );
};

export default CategoryDetailPage;